/*
  Selector de variante de los upsells (snippets/upsell-custom.liquid).

  Permite elegir que variante del producto sugerido se anade al carrito. Antes
  siempre iba product.selected_or_first_available_variant, sin opcion a cambiarla.

  No hay que tocar product-cart-extras.js: ese lee box.dataset.variantId DENTRO
  del handler de envio, no al cargar la pagina. Con mantener ese atributo al dia
  basta para que el carrito reciba la variante correcta.

  Los precios los genera Liquid, uno por variante, y aqui solo se cambia cual
  esta visible: asi la formula del descuento y el formato de moneda siguen en un
  unico sitio, sin replicarlos en JavaScript.
*/
(function () {
  function apply(select) {
    // Se trabaja dentro del .upsell-item mas cercano: en esta tienda hay dos
    // bloques de upsell en la misma pagina y no deben interferir entre si.
    var item = select.closest('.upsell-item');
    if (!item) return;

    var option = select.options[select.selectedIndex];
    if (!option) return;

    var variantId = option.value;

    // 1. El dato que acabara en el carrito.
    var checkbox = item.querySelector('.upsell-checkbox');
    if (checkbox) {
      checkbox.dataset.variantId = variantId;
      checkbox.dataset.sellingPlanId = option.dataset.sellingPlanId || '';
      // El estado del interruptor no se toca a proposito: elegir variante no
      // debe anadir el producto por su cuenta.
    }

    // 2. Mostrar el bloque de precio de esa variante y ocultar los demas.
    Array.prototype.forEach.call(item.querySelectorAll('.upsell-price'), function (price) {
      if (price.dataset.variantId === variantId) {
        price.removeAttribute('hidden');
      } else {
        price.setAttribute('hidden', '');
      }
    });

    // 3. Miniatura, si la variante tiene imagen propia.
    var image = option.dataset.image;
    if (image) {
      var thumb = item.querySelector('.upsell-thumb img');
      if (thumb) thumb.src = image;
    }
  }

  // Delegado en document: sobrevive a que el editor de temas repinte la seccion.
  document.addEventListener('change', function (event) {
    var target = event.target;
    if (!target || !target.classList) return;
    if (!target.classList.contains('upsell-variant-select')) return;
    apply(target);
  });
})();
